

















import Vue, { PropType } from 'vue';
import { VFairWebinar } from '~/services/VFairService';
import defaultBackground from '~/assets/img/vcf/event-default-bg.png';

export default Vue.extend({
    name: 'VideoItem',
    props: {
        value: {
            type: Object as PropType<VFairWebinar>,
            required: true,
        },
    },
    computed: {
        image(): string {
            return this.value.backgroundImage || defaultBackground;
        },
        cleanDescription(): string {
            if (!this.value.description) return '';
            const el = document.createElement('div');
            el.innerHTML = this.value.description;
            return el.innerText;
        },
    },
    methods: {
        handleClick() {
            if (!this.value.url) return;
            window.open(this.value.url, '_blank');
        },
    },
});
